import {Shower} from "../../parts/shower";
import {IntermediatePart} from "../../intermediatePart";
import {ShowerComboTubType, SIDE_POSITIONS} from "../../constants";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {ShowerAccessories} from "../../parts/showerAccessories";

export default class AccessoryCommon extends IntermediatePart {

  constructor(props) {
    super(props);
  }

  getArrayOfConditions() {
    let conditions = super.getArrayOfConditions(); //roomLayout
    const layout = this.getParent().layout;
    const showerParent = layout.parts[Shower.id];
    const showerAccParent = layout.parts[ShowerAccessories.id];
    const showerTubComboParentIsActive = showerParent.showerTubComboIsActive();
    const showerSize = showerParent.showerSize();
    if (showerParent && showerSize) {
      conditions.push({
        propName: "ShowerSize",
        propValue: showerSize
      });
    }
    if (this.partId === "grab_bar") {
      const showerCondition = showerTubComboParentIsActive && layout.parts[ShowerTubCombo.id]
      && (layout.parts[ShowerTubCombo.id].bottomTub === ShowerComboTubType.walk_in_tub)
        ? "Tub"
        : "Shower";
      conditions.push({
        propName: "Shower",
        propValue: showerCondition
      });
    }
    if (this.partId === "seat_pad") {
      conditions.push({
        propName: "MatchingFeature",
        propValue: showerAccParent?.seats?.activeFeature?.dbFeature?.sharedFeatureName || "hide"
      });
    }
    return conditions
  }

  checkRelatedFeatureGroupPositions(position) {
    const accessoriesParent = this.getParent();
    const showerParent = accessoriesParent.layout.parts[Shower.id]; // no need for another check
    const showerSize = showerParent.showerSize();
    let otherFeatureGroup = null;
    switch (this.partId) {
      case "grab_bar":
        otherFeatureGroup = accessoriesParent.soapDish;
        break;
      case "soap_dish":
        otherFeatureGroup = accessoriesParent.grabBar;
        break;
      case "shower_seats":
        otherFeatureGroup = accessoriesParent.largeCornerSeat;
        break;
      case "large_corner_seat":
        otherFeatureGroup = accessoriesParent.seats;
        break;
      default:
        break;
    }
    if (showerSize === "30") {
      if (otherFeatureGroup && otherFeatureGroup.layerPositions && !this.disabled && Object.keys(this.layerPositions).some(key => this.layerPositions[key])) {
        Object.keys(otherFeatureGroup.layerPositions).forEach(key => {
          otherFeatureGroup.layerPositions[key] = null
        });
      }
      if (this.layerPositions) {
        Object.keys(this.layerPositions).forEach(key => {
          if (key !== position) {
            this.layerPositions[key] = null; // it can be only on one side on small shower size
          }
        })
      }
    } else if (otherFeatureGroup && !otherFeatureGroup.disabled) {
      if (this.layerPositions && this.layerPositions[position] && otherFeatureGroup.layerPositions && otherFeatureGroup.layerPositions[position]) {
        const newPosition = position === SIDE_POSITIONS[0] ? SIDE_POSITIONS[1] : SIDE_POSITIONS[0];
        if (!this.layerPositions[newPosition]) {
          const matchingPositionFeature = otherFeatureGroup.getMatchingPositionFeature(newPosition, otherFeatureGroup.layerPositions[position]);
          if (matchingPositionFeature) {
            otherFeatureGroup.layerPositions[newPosition] = matchingPositionFeature;
          }
        }
        otherFeatureGroup.layerPositions[position] = null; //2) remove old soap dish position
      } else if (this.oneLayerPosition && otherFeatureGroup.oneLayerPosition
      && otherFeatureGroup.activeFeature?.metaData?.layerPosition
      && (otherFeatureGroup.activeFeature.metaData["layerPosition"] === position)) {
        const newPosition = position === SIDE_POSITIONS[0] ? SIDE_POSITIONS[1] : SIDE_POSITIONS[0];
        otherFeatureGroup.activeFeature = otherFeatureGroup.getMatchingPositionFeature(newPosition) || null;
      }
    }
    if (this.partId === "shower_seats") {
      if (accessoriesParent.seatPad) {
        if (!this.layerPositions[position]) {
          accessoriesParent.seatPad.layerPositions[position] = null;
        } else {
          const matchingPositionFeature = accessoriesParent.seatPad.getMatchingPositionFeature(position);
          if (matchingPositionFeature && matchingPositionFeature.matchesMetaForCondition(
            "MatchingFeature",
            this?.activeFeature?.dbFeature?.sharedFeatureName || "hide"
          )) {
            accessoriesParent.seatPad.layerPositions[position] = matchingPositionFeature;
          }
        }
      }
    }
  }

}
